import _ from 'lodash';

export default (a, b) => {
  if (_.isArray(a)) {
    return b;
  }
};
